export default __webpack_public_path__ + "static/media/Direction.fff88e87.svg";